const DEFAULT_DURATION_MS = 12000;

export const getSlideDurationMs = (slide) => {
  const configuredSeconds = Number(slide?.duration_seconds);
  if (Number.isFinite(configuredSeconds) && configuredSeconds > 0) {
    return Math.min(Math.max(configuredSeconds, 3), 300) * 1000;
  }
  return DEFAULT_DURATION_MS;
};
